/**
 * Which capture screen produced a manual — lets 「撮影しなおす」(AI生成後) return the user to
 * the SAME entry point (camera video vs screen recording; both are sourceType 'video' on the
 * server, so the data contract can't tell them apart). Best-effort localStorage: when the
 * record is missing, callers fall back to a sourceType-based default.
 */
export type CaptureOrigin = "video" | "image" | "screen";

const key = (manualId: string) => `tebiki.captureOrigin.${manualId}`;

export function rememberCaptureOrigin(manualId: string, origin: CaptureOrigin): void {
  try {
    localStorage.setItem(key(manualId), origin);
  } catch {
    /* storage unavailable (private mode) — fallback path covers it */
  }
}

export function recallCaptureOrigin(manualId: string): CaptureOrigin | null {
  try {
    const v = localStorage.getItem(key(manualId));
    return v === "video" || v === "image" || v === "screen" ? v : null;
  } catch {
    return null;
  }
}

/** Drop the record once the manual is deleted (撮影しなおす / 削除). */
export function forgetCaptureOrigin(manualId: string): void {
  try {
    localStorage.removeItem(key(manualId));
  } catch {
    /* ignore */
  }
}
